// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorKeystore = (client) => ({
    /**
     * `POST /vendor/keystore/entries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpsertKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/vendor/keystore/entries/route.ts
     */
    createEntry: (body, query, headers) => client.fetch("/vendor/keystore/entries", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/keystore/entries/:key_name`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/vendor/keystore/entries/[key_name]/route.ts
     */
    deleteEntry: (keyName, body, query, headers) => client.fetch(buildPath("/vendor/keystore/entries/:key_name", [keyName]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/keystore/entries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListKeystoreEntries
     * @source packages/medusa-plugin-encrypted-store/src/api/vendor/keystore/entries/route.ts
     */
    listEntries: (query, headers) => client.fetch("/vendor/keystore/entries", { method: "GET", query, headers }),
    /**
     * `PUT /vendor/keystore/entries/:key_name`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReplaceKeystoreEntry
     * @source packages/medusa-plugin-encrypted-store/src/api/vendor/keystore/entries/[key_name]/route.ts
     */
    updateEntry: (keyName, body, query, headers) => client.fetch(buildPath("/vendor/keystore/entries/:key_name", [keyName]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=keystore.js.map